import { generateUUID } from "../shared/UUIDGenerator";
import ProductSessionTracker from "./ProductSessionTracker";
class HelloARTracker {
    constructor({ server, sessionId }) {
        this.callbacks = {};
        this.reset = () => {
            this.sessionId = generateUUID();
            this.curentProductSession = undefined;
        };
        this.setEventCallback = (eventName, callback) => {
            this.callbacks[eventName] = callback;
        };
        this.startProductSession = () => {
            this.curentProductSession = new ProductSessionTracker({
                server: this.server,
                parentSessionId: this.sessionId,
            });
        };
        this.getSessionId = () => {
            return this.sessionId;
        };
        if (!sessionId) {
            this.sessionId = generateUUID();
        }
        else {
            this.sessionId = sessionId;
        }
        this.server = server;
    }
}
export default HelloARTracker;
